var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCampusLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64.579,
    height: 68.257,
    viewBox: "0 0 64.579 68.257",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.545,58.145l6.307,6.31,6.31-6.31-6.31-6.306Z",
    transform: "translate(-17.273 -25.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.924,
    height: 8.924,
    transform: "translate(25.977 6.311) rotate(-45.005)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.641,23.632l6.308,6.312,6.309-6.312-6.309-6.306Z",
    transform: "translate(-17.32 -8.663)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.923,
    height: 8.923,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 8.659, 23.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,57.57H12.616L6.309,51.261Z",
    transform: "translate(0 -25.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.278,23.632l6.31,6.312L81.9,23.632l-6.309-6.306Z",
    transform: "translate(-34.639 -8.663)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.923,
    height: 8.923,
    transform: "translate(43.299 23.632) rotate(-45.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.278,57.569H81.9l-6.309-6.31Z",
    transform: "translate(-34.639 -25.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.918,57.57h12.62l-6.31-6.309Z",
    transform: "translate(-51.959 -25.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.922,
    height: 8.922,
    transform: "translate(25.602 23.638) rotate(-44.991)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,95.5c0-3.061,1.916-5.211,4.839-5.211a4.209,4.209,0,0,1,4.329,3.116l-2.22.386a2.083,2.083,0,0,0-2.109-1.641c-1.572,0-2.537,1.282-2.537,3.364s.965,3.351,2.537,3.351a2.161,2.161,0,0,0,2.178-1.778l2.22.386a4.3,4.3,0,0,1-4.412,3.254C1.958,100.729,0,98.6,0,95.5",
    transform: "translate(0 -45.146)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.318,98.935h-4l-.607,1.792h-2.3l3.722-10h2.551l3.709,10H27.924Zm-.662-1.986-1.323-3.971-1.337,3.971Z",
    transform: "translate(-10.205 -45.366)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.717,90.731v10H52.594V92.992l-2.261,7.735H48.278l-2.234-7.735v7.735H43.962v-10h3.392l1.986,6.936,1.986-6.936Z",
    transform: "translate(-21.981 -45.366)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.376,94.068c0,2-1.448,3.323-3.627,3.323h-2.22v3.337H71.268v-10h4.481c2.178,0,3.627,1.324,3.627,3.337M75.5,95.46c.993,0,1.572-.51,1.572-1.393s-.579-1.407-1.572-1.407H73.529v2.8Z",
    transform: "translate(-35.634 -45.366)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.291,96.288V90.731h2.262v5.584c0,1.889.606,2.771,1.958,2.771,1.324,0,1.93-.855,1.93-2.771V90.731h2.248v5.557c0,3.075-1.392,4.66-4.191,4.66-2.771,0-4.205-1.557-4.205-4.66",
    transform: "translate(-45.646 -45.366)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.115,97.957l2.151-.634a2.307,2.307,0,0,0,2.358,1.6c1.1,0,1.806-.5,1.806-1.214,0-.813-.868-1.007-2.261-1.351-2.013-.51-3.7-1.021-3.7-3.006,0-1.917,1.545-3.061,3.916-3.061,2.013,0,3.5.855,3.985,2.33l-2.151.634a1.992,1.992,0,0,0-1.944-1.158c-.9,0-1.586.4-1.586,1.034,0,.772.9.965,2.275,1.31,2.137.538,3.668,1.089,3.668,3.006,0,2-1.641,3.282-4.109,3.282-2.275,0-4.054-1.09-4.412-2.771",
    transform: "translate(-56.058 -45.146)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.008,115.968H6.981v1.941h-4.7v2.5H6.468v1.941H2.282v3.674H.008Z",
    transform: "translate(-0.004 -57.984)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.831,126.019l-2.2-3.494H22.254v3.494H19.98V115.968h4.451c2.218,0,3.7,1.317,3.7,3.285a3.052,3.052,0,0,1-2.163,3.022l2.482,3.743Zm-3.577-5.407h1.705c1.248,0,1.858-.443,1.858-1.358,0-.846-.554-1.345-1.5-1.345H22.254Z",
    transform: "translate(-9.99 -57.984)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.531,124.216H43.51l-.61,1.8H40.585l3.743-10.051h2.564l3.729,10.051H48.141Zm-.666-2-1.331-3.993-1.345,3.993Z",
    transform: "translate(-20.293 -57.984)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.126,115.968h2.315l3.868,6.543v-6.543h2.232v10.051H72.226l-3.868-6.544v6.544H66.126Z",
    transform: "translate(-33.063 -57.984)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.532,120.764c0-3.078,1.927-5.24,4.866-5.24a4.233,4.233,0,0,1,4.354,3.133l-2.232.389A2.1,2.1,0,0,0,94.4,117.4c-1.58,0-2.551,1.289-2.551,3.383s.971,3.369,2.551,3.369a2.173,2.173,0,0,0,2.19-1.789l2.232.389a4.329,4.329,0,0,1-4.436,3.272c-2.884,0-4.852-2.135-4.852-5.255",
    transform: "translate(-44.766 -57.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.129,115.968h7.306v1.941H116.4v2.038h4.45v1.913H116.4v2.218h5.24v1.941h-7.514Z",
    transform: "translate(-57.064 -57.984)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampusLogo);
export default __webpack_public_path__ + "static/media/campus-logo.a85f4db9c8ac8a25224767d1466042e8.svg";
export { ForwardRef as ReactComponent };